export const API_GET_LEADS = "API_GET_LEADS"
export const RESET_LEADS = "RESET_LEADS"
